export default __webpack_public_path__ + "static/media/nausea-and-vomiting.96a4c748.png";